import styled from "styled-components";

export const WebContentArea = styled.div`
    width: 73vw;
    margin: auto;
    padding-top: 6rem;
`